export const LOGIN_ITEM = {
  headerTitle: {
    title: {
      vi: 'Đăng nhập',
      en: 'Login',
    },
  },
  userName: {
    title: {
      vi: 'Tài khoản',
      en: 'Username',
    },
    error: '',
  },
  passWord: {
    title: {
      vi: 'Mật khẩu',
      en: 'Password',
    },
    error: '',
  },
  rememberMe: {
    title: {
      vi: 'Nhớ mật khẩu',
      en: 'Remember me',
    },
    checked: false,
  },
  loginButton: {
    title: {
      vi: 'Đăng nhập',
      en: 'Login',
    },
  },
  googleButton: {
    title: {
      vi: 'Google',
      en: 'Google',
    },
    path: '/google/',
  },
  forgotPw: {
    title: {
      vi: 'Quên mật khấu?',
      en: 'Forgot password?',
    },
    path: '/forgot-password/',
  },
  createAccount: {
    title: {
      vi: 'Tạo tài khoản mới',
      en: 'Create new account',
    },
    path: '/regiter/',
  },
};
